module.exports = __webpack_public_path__ + "img/headphone-2.cda82b1d.jpg";